// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__mKLDJ","col":"styles_col__18kik","fulfillmentStatus":"styles_fulfillmentStatus__iIm9G","emailCol":"styles_emailCol__3w64e"};